import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg font-bold text-background-50 mb-4">
              51黑料
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              51黑料网致力于为用户提供最新、最全面的娱乐八卦、明星爆料、网红热点及社会事件深度揭秘内容，是您获取一手资讯的首选平台。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  网站首页
                </Link>
              </li>
              <li>
                <Link to="/category/latest" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  最新爆料
                </Link>
              </li>
              <li>
                <Link to="/category/celebrity" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  明星八卦
                </Link>
              </li>
              <li>
                <Link to="/category/investigation" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  深度揭秘
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              热门栏目
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/influencer" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  网红热点
                </Link>
              </li>
              <li>
                <Link to="/category/social" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  社会事件
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  联系我们
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              关注我们
            </h4>
            <p className="text-sm text-background-400 mb-4">
              关注51黑料官方账号，第一时间获取最新爆料资讯。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 51黑料网 版权所有 | 51黑料网站官网
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}